import type { ApiKey } from '../../lib/flotiq-client/types/api-response';
import type { ParsedApiKeyData } from './modal/UsedApiKeyGuardModalContent';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useModals } from '../../contexts/ModalContext';

import { UsedApiKeyGuardModalContent } from './modal/UsedApiKeyGuardModalContent';

const modalTitle = {
  userForm: 'ApiKeyGuardModal.Modal.UserFormTitle',
  spaceForm: 'ApiKeyGuardModal.Modal.SpaceFormTitle',
};

type currentData = {
  id: string;
  name: string;
};

const useUsedApiKeyGuard = (
  mode: 'userForm' | 'spaceForm',
  lastUsedKeys?: Record<string, Pick<ApiKey, 'id' | 'lastUsedAt'>[]>,
  formMode: string = 'edit',
) => {
  const modal = useModals();
  const { t } = useTranslation();

  const usedApiKeyGuard = useCallback(
    async (name: string, diff: currentData[]) => {
      if (formMode === 'add') {
        return true;
      }

      const names = diff.map(({ name }) => name).join(', ');

      const objectsWithUsedKeys = diff.filter(
        ({ id }) => lastUsedKeys?.[id] !== undefined,
      );

      const apiKeys = objectsWithUsedKeys.reduce((acc, { id, name }) => {
        // @ts-expect-error lastUsedKeys cant be undefined here
        const keys = lastUsedKeys[id].map((element) => ({
          spaceId: id,
          name,
          ...element,
        }));
        // @ts-expect-error lastUsedKeys cant be undefined here
        return acc.concat(...keys);
      }, [] as ParsedApiKeyData[]);

      if (!diff.length) {
        return true;
      }

      return modal({
        title: t(modalTitle[mode], {
          name,
        }),
        content: (
          <UsedApiKeyGuardModalContent
            target={name}
            subject={names}
            apiKeys={apiKeys}
            mode={mode}
          />
        ),
        size: 'xl',
        contentAdditionalClasses: 'xl:!pt-0',
        dialogAdditionalClasses: 'pt-6',
      });
    },
    [lastUsedKeys, modal, mode, formMode, t],
  );

  return { usedApiKeyGuard };
};

export default useUsedApiKeyGuard;
